import { render, staticRenderFns } from "./save.vue?vue&type=template&id=59f668bd&scoped=true&"
import script from "./save.vue?vue&type=script&lang=js&"
export * from "./save.vue?vue&type=script&lang=js&"
import style0 from "./save.vue?vue&type=style&index=0&id=59f668bd&prod&lang=scss&scoped=true&"
import style1 from "./save.vue?vue&type=style&index=1&id=59f668bd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f668bd",
  null
  
)

export default component.exports